import React, {Component} from 'react';
import {Button} from 'react-bootstrap'
import FontAwesome from 'react-fontawesome'
import InsurerPageModal from '../insurer/InsurerPageModal'

class SWTNewInsurerButton extends Component {

  constructor(...args){
    super(...args)
    this.state = {show:false}
  }

  onClick(){
    this.setState({show:true})
  }

  onSelect(e) {
  	console.log('e=>',e)
  }

  render(){
    let {show} = this.state
    return (
      <div>        
        <Button  onClick={this.onClick.bind(this)}><FontAwesome name='plus'/></Button>
        <InsurerPageModal 
        	ref={'newInsurer'} 
          show={show} 
          onChange={this.props.onChange}
        	onHide={()=>{this.setState({show:false})}}
        	onSelect={this.onSelect.bind(this)}
        />
      </div>
    )
  }
}


export default SWTNewInsurerButton;





// WEBPACK FOOTER //
// ./src/view/workdoc/SWTNewInsurerButton.js